export default __webpack_public_path__ + "static/media/element_spec_50.67992b6c.webp";